import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import sprintf from 'sprintf'

import Arrow from './arrow.jsx'

let intervalId = null

class Scroll extends Component {
  static displayName = 'React Horizontal Scroll';

  constructor (props) {
    super(props)

    this.state = {
      offset: 0,
      width: 0,
      height: 0,
      offsetLeft: 0,
      offsetTop: 0,
      scrollLeft: 0,
      scrollWidth: 0,
      canScrollLeft: false,
      canScrollRight: false
    }

    this._onScroll = this.onScroll.bind(this)
    this._onResize = this.onResize.bind(this)
  }

  static propTypes = {
    children: PropTypes.element,
    className: PropTypes.string,
    relative: PropTypes.bool
  };

  componentDidMount () {
    const element = ReactDOM.findDOMNode(this)

    this.setState({
      height: window.innerHeight,
      width: element.offsetWidth,
      offsetLeft: element.offsetLeft,
      offsetTop: element.offsetTop
    })

    intervalId = setInterval(() => {
      this.setScrollState()
    }, 250)

    element.addEventListener('scroll', this._onScroll)
    window.addEventListener('resize', this._onResize)
  }

  componentWillUnmount () {
    const element = ReactDOM.findDOMNode(this)

    if (intervalId) {
      clearInterval(intervalId)
    }

    element.removeEventListener('scroll', this._onScroll)
    window.removeEventListener('resize', this._onResize)
  }

  componentDidUpdate () {
    const target = ReactDOM.findDOMNode(this)
    const offset = this.state.offset
    const position = offset || 0

    target.scrollLeft = position
  }

  onScroll (event) {
    event.preventDefault()
    event.stopPropagation()

    const offset = event.target.scrollLeft
    this.setScrollState(offset)
  }

  onResize (event) {
    event.preventDefault()
    event.stopPropagation()

    this.setScrollState()
  }

  setScrollState (offset) {
    const element = ReactDOM.findDOMNode(this)
    const scrollWidth = element.scrollWidth
    const scrollLeft = this.props.relative
      ? element.scrollLeft + 1
      : element.scrollLeft
    let canScrollRight = false

    if (offset === undefined) {
      offset = this.state.offset
    }

    if (scrollLeft < element.scrollWidth - element.offsetWidth) {
      canScrollRight = true
    }

    if (!scrollLeft && !(element.scrollWidth - element.offsetWidth)) {
      canScrollRight = true
    }

    this.setState({
      height: window.innerHeight,
      width: element.offsetWidth,
      offset: offset,
      scrollLeft: element.scrollLeft,
      scrollWidth: scrollWidth,
      offsetLeft: element.offsetLeft,
      offsetTop: element.offsetTop,
      canScrollLeft: offset > 0,
      canScrollRight: canScrollRight
    })
  }

  scrollLeft () {
    const element = ReactDOM.findDOMNode(this)
    const offset = element.scrollLeft - element.scrollWidth // element.scrollLeft + element.scrollWidth * 0.15;

    this.setScrollState(offset)
  }

  scrollRight () {
    const element = ReactDOM.findDOMNode(this)
    const offset = element.scrollLeft + element.scrollWidth // element.scrollLeft + element.scrollWidth * 0.15;

    this.setScrollState(offset)
  }

  render () {
    const body = document.body
    let className = 'horizontal-scrolling'
    const windowInnerHeight = window.innerHeight
    const relative = this.props.relative || false

    const offsetTop = this.state.offsetTop
    const offsetLeft = this.state.offsetLeft

    const height = this.state.height
    const width = this.state.width

    const scrollWidth = this.state.scrollWidth
    const scrollTop = body.scrollTop

    const bottom = relative
      ? height - scrollTop
      : windowInnerHeight - scrollTop
    let top = Math.max(offsetTop, scrollTop)
    const left = offsetLeft
    const right = offsetLeft + width - 60

    let canScrollLeft = this.state.canScrollLeft
    let canScrollRight = this.state.canScrollRight

    top = (bottom - top - 35) / 2 + top // 70px arrow height
    if (offsetTop >= windowInnerHeight || offsetTop + height < scrollTop) {
      canScrollLeft = false
      canScrollRight = false
    }

    if (scrollWidth <= width) {
      canScrollLeft = false
      canScrollRight = false
    }

    if (this.props.className) {
      className = sprintf('%s %s', className, this.props.className)
    }

    const showButton = !!(canScrollLeft || canScrollRight)
    return (
      <div className={className}>
        {showButton && (
          <div className='scollbtns'>
            <Arrow
              onClick={this.scrollRight.bind(this)}
              show={canScrollRight}
              top={top}
              left={right}
              relative={relative}
              direction='right'
            />
            <Arrow
              onClick={this.scrollLeft.bind(this)}
              show={canScrollLeft}
              top={top}
              left={left}
              relative={relative}
            />
          </div>
        )}
        {this.props.children}
      </div>
    )
  }
}

export default Scroll
